import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-link';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M13.98 4.44 12.021 6.4l.539.54.539.54 1.701-1.7 1.7-1.7 1.71 1.71 1.71 1.71-3.41 3.408-3.41 3.407-.899-.858c-.495-.471-.911-.853-.925-.847a13 13 0 0 0-.528.532l-.502.523 1.182 1.127 1.183 1.128h1.049l3.93-3.93 3.93-3.93V6.94l-2.23-2.23-2.23-2.23h-1.12zm-3.645 3.669c-.105.013-.739.637-3.98 3.921L2.5 15.935l-.011.561-.011.561 2.231 2.232L6.94 21.52h1.12l1.96-1.96 1.959-1.96-.519-.52c-.285-.286-.537-.52-.559-.52s-.797.756-1.721 1.68L7.5 19.92l-1.718-1.718-1.717-1.717 2.478-2.507c1.362-1.379 2.873-2.912 3.357-3.407l.88-.898.895.853c.492.47.907.859.923.865s.257-.23.536-.525l.505-.536-1.176-1.125-1.177-1.125-.413.006a8 8 0 0 0-.538.023"
    })
  }));
});
export default SvgLink;